export const smsKeys = {
  all: [{ module: 'sms' }] as const,
  countries: () => [{ ...smsKeys.all[0], scope: 'countries' }] as const,
  whitelist: () => [{ ...smsKeys.all[0], scope: 'whitelist' }] as const,
};
